"use client";

import React from "react";

interface HeadCustomCodeProps {
  code?: string;
}
export default function HeadCustomCode({ code }: HeadCustomCodeProps) {
  const isCodeAddedRef = React.useRef(false);
  React.useEffect(() => {
    if (code && !isCodeAddedRef.current) {
      const parsedHTML = document.createRange().createContextualFragment(code);
      document.head.appendChild(parsedHTML);
      isCodeAddedRef.current = true;
    }
  }, [code]);
  return null;
}
